interface StateGridProps {
  states: string[]
  type: 'projected' | 'delivered'
}

export default function StateGrid ({ states, type }: StateGridProps) {
  const colorClass = type === 'projected' ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'

  if (states.length === 0) {
    return <div className='text-gray-400 text-sm'>No states</div>
  }

  return (
    <div className='grid grid-cols-10 gap-1'>
      {states.map(state => (
        <span key={state} className={`inline-flex items-center justify-center px-1 py-0.5 rounded text-xs font-medium ${colorClass}`}>
          {state}
        </span>
      ))}
    </div>
  )
}
